import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useSelector } from "react-redux";
import { usersSliceSelector } from "../../../redux/features/usersSlice";

export default function DevToolsRoute() {
  const { user, authState } = useSelector((state) => usersSliceSelector(state));
  const isDeveloper = user?.developer === true;

  // Wait for auth to initialize
  if (authState === null || authState === "pending") {
    return null;
  }

  // Redirect if not authenticated or not developer
  if (authState !== "in" || !isDeveloper) {
    return <Navigate to="/" replace />;
  }

  return <Outlet />;
}
